<div id="page-footer">
  <div class="footer-company-info">
    <a href="mailto:support@mi4.com?Subject=Portal%20Issue"><p class="footer-contact">support&#64;mi4.com</p></a>
    <a href="tel:1-713-401-9584"><p class="footer-contact footer-contact-middle">(713) 401-9584</p></a>
    <p class="footer-contact">Houston, TX</p>
  </div>
  <div class="footer-company-info">
    <p class="footer-copyright">Copyright &copy; {{year}} <a href="https://www.mi4.com">Mi4 Corporation</a></p>
  </div>
</div>
